module.exports = __webpack_public_path__ + "static/media/success.b0fe1f48.svg";